/**
 * 객체 설정 > 서비스 객체 Store
 *
 * @since 2018-06-12
 * @author kdydesign.kim
 */

// TAMS
import {ObjectSecProfileApiPrefix as objApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'
import {isPreDefine} from 'objectSettingsUtils'

// <editor-fold desc="Util Function">
// 서비스 객체 데이터
const initServiceData = () => {
  return {
    // name: '',
    // prtc_id: 5,
    // srv_cate: 0,
    // start_port: '*',
    // srv_port: null,
    // life_time: 1800,
    // prio: 1,
    // desc: ''
    // TAMS
    srv_obj_uname: '',
    prtc_obj_id: 5,
    srv_obj_cate_type: 0,
    srv_obj_src_port_exp: '*',
    srv_obj_dst_port_exp: null,
    srv_obj_life_time_num: 1800,
    srv_obj_prio_num: 1,
    srv_obj_desc: '',
    srv_obj_pre_def_yn: 0,
    cfg_layer: 1
  }
}

// 서비스 Any 객체 데이터
const initAnyServiceData = () => {
  return {
    name: void 0,
    desc: void 0,
    tcp: 1800,
    udp: 1800,
    icmp: 1800,
    others: 1800
  }
}

// TAMS 미사용
// const isShowRefs = (newObj, oldObj, objectType) => {
//   const refObj = _.get(newObj, ['ref'], {})
//   let isRefs = false
//   if (Number(_.get(newObj, ['srv_obj_id'], -1)) === 0) { // Any는 refs가 없어도 변경사항 체크
//     isRefs = true
//   } else {
//     Object.keys(refObj).forEach((key) => {
//       if (!/ref$/.test(key)) return
//       if (refObj[key] === true && ['fw_ref', 'fw6_ref', 'nat_ref'].indexOf(key) >= 0) {
//         isRefs = true
//       }
//     })
//   }
//
//   if (!isRefs) return false
//   // #31916 - 이슈에서 정의
//   let pickList = ['start_port', 'srv_port']
//   const newD = _.pick(newObj, pickList)
//   const oldD = _.pick(oldObj, pickList)
//   const res = !_.isEqual(newD, oldD)
//   return res
// }

const moveArr = (arr, pos1, pos2) => {
  let i, tmp
  pos1 = parseInt(pos1, 10)
  pos2 = parseInt(pos2, 10)
  const isCond = [pos1 !== pos2, pos1 >= 0, pos1 <= arr.length, pos2 >= 0, pos2 <= arr.length].every(c => c)
  if (isCond) {
    tmp = arr[pos1]
    if (pos1 < pos2) {
      for (i = pos1; i < pos2; i++) {
        arr[i] = arr[i + 1]
      }
    } else {
      for (i = pos1; i > pos2; i--) {
        arr[i] = arr[i - 1]
      }
    }
    arr[pos2] = tmp
  }
  return arr
}
// </editor-fold>

export const state = () => ({
  serviceData: initServiceData(),
  anyServiceData: initAnyServiceData(),
  serviceObjectDataList: [],
  parseServiceCategory: [],
  serviceCategory: [],
  selectedData: void 0,
  serviceMenu: '', // SSL 정책설정 메뉴에서는 SSL, HTTPS, SMTPS, POP3S, IMAPS, FTPS 만 조회되어야하기때문에 메뉴구분을 위해서 추가
  copyData: void 0
})

export const mutations = {
  // 서비스 유형 조회
  getServiceCategory (state, data) {
    const parseServiceCategory = _.map(data, (value) => {
      const key = _.keys(value)[0]
      return {
        label: key,
        value: value[key],
        use_tcp: value.use_tcp,
        use_udp: value.use_udp
      }
    })
    state.parseServiceCategory = Object.freeze(parseServiceCategory)
    state.serviceCategory = Object.freeze(data)
  },

  resetServiceCopyData (state) {
    state.copyData = void 0
  },

  // 서비스 객체 초기화
  resetServiceObjectData (state) {
    state.serviceData = initServiceData()
    state.anyServiceData = initAnyServiceData()
  },

  // 서비스 객체 목록 조회
  getServiceObjectDataList (state, data) {
    // SSL 정책 설정에서는 서비스유형 = HTTPS(7), SMTPS(8), POP3S(9), SSL(10), IMAPS(15), FTPS(19)만 조회해야한다.
    if (state.serviceMenu === 'sslTrafficChk') {
      state.serviceObjectDataList = []

      for (const key of data) {
        // TAMS
        if ([7, 8, 9, 10, 15, 19].includes(key.srv_obj_cate_type)) {
          state.serviceObjectDataList.push(key)
        }
      }
    } else {
      state.serviceObjectDataList = Object.freeze(data)
    }
  },

  // 서비스 객체 목록 초기화
  resetServiceObjectDataList (state) {
    state.serviceObjectDataList = []
  },

  // 서비스 객체 저장
  setServiceObjectData (state, data) {
    const serviceObjectDataList = _.cloneDeep(state.serviceObjectDataList)
    let itemIndex = _.findIndex(state.serviceObjectDataList, {prio: data.prio})

    if (itemIndex < 0) {
      itemIndex = 1
    }

    serviceObjectDataList.splice(itemIndex, 0, data)

    // 우선 순위 업데이트
    _.forEach(serviceObjectDataList, (o, i) => {
      if (o.prio && i > itemIndex) {
        _.assign(o, {
          prio: o.prio + 1
        })
      }
    })

    state.serviceObjectDataList = Object.freeze(serviceObjectDataList)
  },

  // 서비스 객체 선택
  selectedServiceObject (state, data) {
    state.selectedData = data
  },

  // 서비스 객체 조회
  getServiceObjectData (state, data) {
    // TAMS
    state.serviceData = data
  },

  // 서비스 객체 수정
  updateServiceObjectData (state, data) {
    state.serviceObjectDataList = Object.freeze(_.map(state.serviceObjectDataList, (o) => {
      if (o.srv_obj_id === data.srv_obj_id) {
        o = data
      }

      return o
    }))
  },
  updatePriority (state, data) {
    const serviceId = _.get(data, ['srv_obj_id'], -1)
    const prio = _.get(data, ['prio'], -1)
    if (serviceId === -1) return
    const fromIndex = _.findIndex(state.serviceObjectDataList, (o) => (o['srv_obj_id'] === serviceId))
    const toIndex = _.findIndex(state.serviceObjectDataList, (o) => (o['prio'] === prio))

    const tempArr = moveArr(_.cloneDeep(state.serviceObjectDataList), fromIndex, toIndex)
    for (let i = 1, l = _.size(state.serviceObjectDataList); i < l; i++) { // 0, any 는 제외
      const beforePiriority = _.get(state.serviceObjectDataList, [i, 'prio'])
      _.set(tempArr, [i, 'prio'], beforePiriority)
    }
    state.serviceObjectDataList = tempArr
  },

  // 서비스 객체 삭제
  deleteServiceObjectData (state, data) {
    const serviceObjectDataList = _.cloneDeep(state.serviceObjectDataList)
    const itemIndex = _.findIndex(serviceObjectDataList, {srv_obj_id: data})

    serviceObjectDataList.splice(itemIndex, 1)

    // #20798 - [QA Phase1] [Object > 서비스 객체 > 추가] 서비스 객체 입력 시 기존 객체 우선 순위가 변경되지 않음 이슈 수정
    // 우선 순위 업데이트
    _.forEach(serviceObjectDataList, (o, i) => {
      if (o.prio && i >= itemIndex) {
        _.assign(o, {
          prio: o.prio - 1
        })
      }
    })

    state.serviceObjectDataList = Object.freeze(serviceObjectDataList)
  },

  // 서비스 객체 일괄 삭제
  deleteBatchServiceObjectData (state, data) {
    const serviceObjectDataList = _.cloneDeep(state.serviceObjectDataList)

    _.forEach(data, (o) => {
      const itemIndex = _.findIndex(serviceObjectDataList, {srv_obj_id: o.srv_obj_id})

      serviceObjectDataList.splice(itemIndex, 1)
    })

    // #20798 - [QA Phase1] [Object > 서비스 객체 > 추가] 서비스 객체 입력 시 기존 객체 우선 순위가 변경되지 않음 이슈 수정
    // 우선 순위 업데이트
    _.forEach(serviceObjectDataList, (o, i) => {
      if (o.prio && i >= 1) {
        _.assign(o, {
          prio: i
        })
      }
    })

    state.serviceObjectDataList = Object.freeze(serviceObjectDataList)
  },

  // 선택된 객체 초기화
  resetObjectSelectData (state) {
    state.selectedData = void 0
  },

  // 서비스 객체 복사
  copyServiceData (state) {
    // TAMS
    state.copyData = _.cloneDeep(state.selectedData)
  },

  // 서비스 객체 붙여넣기
  pasteServiceData (state) {
    if (!state.copyData) return
    state.serviceData = _.assign(_.cloneDeep(state.copyData), {
      // 'pre_def': 0
      // TAMS
      'srv_obj_pre_def_yn': 0
    })
  },

  // 실행되는 메뉴 설정
  setServiceMenu: (state, data) => {
    state.serviceMenu = data
  },

  // lifeTime 수정
  saveBatchLifeTime (state, data) {
    state.serviceObjectDataList = Object.freeze(_.map(state.serviceObjectDataList, (o) => {
      _.map(data, (o2) => {
        if (o.srv_obj_id === o2.srv_obj_id) {
          _.assign(o, {
            // TAMS
            srv_obj_life_time_num: o2.srv_obj_life_time_num
          })
        }
      })

      return o
    }))
  },

  // 서비스 유형 초기화
  initServiceCate (state) {
    // TAMS
    state.serviceData.srv_obj_cate_type = 0
  }
}

export const actions = {
  // 서비스 유형 조회
  async getServiceCategory ({commit}, {target = void 0, loadingShow = false, filter, loadingHide = true} = {}) {
    // TAMS
    const {code, result} = await this.$axios.$get(`${cmApiPrefix}/objects/srv/categories`, {
      loadingShow,
      loadingHide
    })

    if (code === 'ok') {
      commit('getServiceCategory', result)
    }
  },

  // 서비스 객체 목록 조회
  async getServiceObjectDataList ({commit, dispatch, state}, {target = void 0, loadingShow = true, loadingHide = true} = {}) {
    let url = ''
    // TAMS
    const
      srvObjId = 0, // 서비스 객체 아이디, 0인 경우 전체 조회
      srvObjType = 1 // 서비스 객체 유형, 1 서비스 객체, 2 서비스 그룹 객체, 0인 경우 전체 조회
    url = `${cmApiPrefix}/objects/srv/${srvObjId}/${srvObjType}`

    const {code, result} = await this.$axios.$get(url, {loadingShow, loadingHide})

    if (code === 'ok') {
      if (target !== 'group') {
        commit('getServiceObjectDataList', result)
      } else {
        commit('cm/objectSecProfile/object/objectSettings/groupObject/setServiceObjDataList', result, {root: true})
      }
    }
  },

  // 서비스 객체 저장
  // TAMS
  async saveServiceObjectData ({commit, dispatch, state}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const serviceData = state.serviceData
    // TAMS 임시 제외
    // 우선 순위 조절 기능 없음. 추후 반영 시 해제 (2019-11-27)
    // // 선택된 서비스 객체가 있을 경우 추가할 객체의 prio를 선택된 서비스 객체의 prio로 설정
    // serviceData.prio = _.get(state, ['selectedData', 'prio'], false) ? state.selectedData.prio : 1
    // TAMS
    serviceData.srv_obj_desc = _.isUndefined(serviceData.srv_obj_desc) ? '' : serviceData.srv_obj_desc
    serviceData.force_yn = forceYn

    // TAMS
    const res = await this.$axios.$post(`${cmApiPrefix}/objects/srv`, serviceData, {
      loadingShow,
      loadingHide,
      successAlert
    })

    if (res.code === 'ok') {
      // TAMS 불필요
      // commit('setServiceObjectData', res.result)
      // // 선택된 서비스 객체 초기화
      // commit('resetObjectSelectData')

      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },

  // 서비스 객체 수정
  // TAMS
  async updateServiceObjectData ({commit, state, dispatch, rootState}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    // TAMS 제외
    // const objectType = rootState.cm.objectSecProfile.object.objectSettings.common.objectType
    // const objectId = state.selectedData.srv_obj_id
    const data = state.serviceData

    // TAMS
    data.srv_obj_desc = _.isUndefined(data.srv_obj_desc) ? '' : data.srv_obj_desc
    data.force_yn = forceYn

    // TAMS
    const res = await this.$axios.$put(`${cmApiPrefix}/objects/srv`, data, {
      loadingShow,
      loadingHide,
      successAlert
    })

    if (res.code === 'ok') {
      // TAMS 불필요
      // const isShowRefsD = isShowRefs(result, state.selectedData, objectType) // 편집 시 방화벽 정책 재적용 확인
      // commit('updateServiceObjectData', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },

  // 우선 순위 변경
  async updatePriority ({state, commit, dispatch}, {serviceId = '', prio = void 0, loadingShow = true, loadingHide = true} = {}) {
    if (serviceId === 0) {
      return void 0
    }
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/service/objects/${serviceId}`, {prio: prio}, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('updatePriority', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },

  // 서비스 객체 조회
  async getServiceObjectData ({commit, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.srv_obj_id
    // TAMS
    const
      srvObjType = 1 // 서비스 객체 유형, 1 서비스 객체, 2 서비스 그룹 객체, 0인 경우 전체 조회
    const {code, result} = await this.$axios.$get(`${cmApiPrefix}/objects/srv/${objectId}/${srvObjType}`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('getServiceObjectData', result[0])
    }
  },

  // 서비스 객체 삭제
  // TAMS 미사용 (단일, 다수 관계 없이 동일 API 사용)
  async deleteServiceObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.srv_obj_id
    if (isPreDefine(state.selectedData)) {
      return {isPreDefine: true}
    }
    let code = void 0
    let cause = void 0
    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/service/objects/${objectId}`, {isReturnError: true, loadingShow, loadingHide})
      code = _.get(response, ['code'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }

    if (code === 'ok') {
      commit('deleteServiceObjectData', objectId)
      commit('resetObjectSelectData')

      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetObjectSelectData')
      return true
    } else if (Number(code) === 15010) {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [_.assign(selectedData, {cause: cause})]
      }
    } else {
    // } else if (Number(code) === 12004 || Number(code) === 15011) {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },

  // 서비스 객체 일괄 삭제
  // TAMS
  // 서비스 그룹객체도 사용함.
  // 서비스 그룹의 경우 groupObject의 store를 사용하여 표현하나 삭제 후 TAMS의 경우 GUI 작업 없이 다시 Reload 되기 때문에 문제 없음
  // 동일 API 중복으로 인한 유지관리 이원화를 막기 위해 같은 Action을 사용함.
  async deleteBatchServiceObjectData ({commit, dispatch, state}, {forceYn = 0} = {}) {
    // TAMS
    const url = `objects/srv/multi`
    const id = 'srv_obj_id'
    let srvObjIdList = []
    let multiSelectedData = []
    const selectedData = _.cloneDeep(state.selectedData)

    if (_.get(selectedData, ['length'], 0) > 0) {
      srvObjIdList = _.map(selectedData, item => item[id])
      multiSelectedData = selectedData
    } else {
      srvObjIdList = [selectedData[id]]
      multiSelectedData = [selectedData]
    }
    const params = {
      srv_obj_id_list: srvObjIdList,
      force_yn: forceYn
    }

    const res = await this.$axios.$put(`${cmApiPrefix}/${url}`, params, {successAlert: false})

    if (res.code === 'ok') {
      res.result.can_not_delete = _.get(res.result, ['can_not_delete'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      res.result.force_delete_pass = _.get(res.result, ['force_delete_pass'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetObjectSelectData')
    }
    return res
  },

  // LifeTime 일괄 설정
  // TAMS (params)
  async saveBatchLifeTime ({commit, state, dispatch}, {items} = {}) {
    // TAMS
    const res = await this.$axios.$put(`${cmApiPrefix}/objects/srv/lifetime`, items)
    if (res.code === 'ok') {
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    // TAMS
    return res
  },

  // 실행되는 메뉴 설정
  async setServiceMenu ({commit, state}, data) {
    commit('setServiceMenu', data)
  },

  // 서비스 객체 참조 여부 상세 조회
  // TAMS 제외 (미사용, TAMS 전용 통합 API를 통해 참조 여부 조회)
  async getServiceDetailRefData ({commit, state}, {objectData, loadingShow = true, loadingHide = true} = {}) {
    const objId = objectData.srv_obj_id
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/service/objects/${objId}/ref`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('cm/objectSecProfile/object/objectSettings/common/setUsedDetailData', result, {root: true})
    }
  }
}

export const getters = {
}

export const strict = false
